module.exports = __webpack_public_path__ + "img/ebc_logo.36978fdb.svg";